import ClientFactory from "./factory";

const factory = new ClientFactory();

/**
 * HTTP Client for lattice consumption
 * check: https://github.com/localeai/lattice-consumption
 */
const consumptionAPI = factory.create({
  name: "Consumption API",
  baseURL: process.env.VUE_APP_API_URL,
  requireAuth: true,
  checkResponse: true,
});

/**
 * HTTP Client for public requests without any authentication required
 */
const consumptionPublic = factory.create({
  name: "Consumption public",
  baseURL: process.env.VUE_APP_API_URL,
  requireAuth: false,
  checkResponse: true,
});

/**
 * HTTP Client for polaris geomaster
 * check: https://github.com/localeai/locale-polaris
 */
const geoMasterAPI = factory.create({
  name: "GeoMaster API",
  baseURL: process.env.VUE_APP_GEOMASTER_URL,
  requireAuth: true,
  checkResponse: true,
});

/**
 * MapBox API Client
 */
const mapboxAPI = factory.create({
  name: "MapBox API",
  baseURL: process.env.VUE_APP_MAPBOX_API_URL,
  requireAuth: false,
  checkResponse: true,
});

export { consumptionAPI, consumptionPublic, geoMasterAPI, mapboxAPI };
